export default __webpack_public_path__ + "static/media/logo_Hellobank_xerius.9a0b013b.png";